import { useRef } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { withErrorBoundary } from "../../../ErrorBoundary";
import { Icon, ImageAddIcon } from "../../../Icon";
import styles from "./GalleryImageAdd.style";

const UploaderGalleryImageAddStyled = styled.button((props) => ({ ...styles(props) }));

const UploaderGalleryImageAdd = ({ label, onClick, className, ...rest }) => {
    const fileInputRef = useRef();

    // onClick
    const handleClick = (event, ...args) => {
        if (!fileInputRef.current) {
            return;
        }

        fileInputRef.current.click();
    };

    const onImageAdd = (event) => {
        const fileList = event.target.files;

        if (fileList.length < 1) {
            return;
        }

        const imageArray = Array.from(fileList);

        const imageFile = {
            file: imageArray[0],
            url: URL.createObjectURL(imageArray[0]),
        };

        onClick(imageFile);
    };

    return (
        <UploaderGalleryImageAddStyled onClick={handleClick} className={className} {...rest}>
            <span className="btnIcon">
                <Icon icon={ImageAddIcon} />
            </span>
            <input
                style={{ display: "none" }}
                type="file"
                accept="image/*"
                onChange={onImageAdd}
                ref={fileInputRef}
            />
            {label}
        </UploaderGalleryImageAddStyled>
    );
};

UploaderGalleryImageAdd.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

UploaderGalleryImageAdd.defaultProps = {
    label: "Dodaj novu",
    onClick: () => {},
    className: undefined,
};

export default withErrorBoundary(UploaderGalleryImageAdd);
